/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { InboundDocumentState } from './InboundDocumentState';
import {
    InboundDocumentStateFromJSON,
    InboundDocumentStateFromJSONTyped,
    InboundDocumentStateToJSON,
    InboundDocumentStateToJSONTyped,
} from './InboundDocumentState';
import type { InboundDocumentLead } from './InboundDocumentLead';
import {
    InboundDocumentLeadFromJSON,
    InboundDocumentLeadFromJSONTyped,
    InboundDocumentLeadToJSON,
    InboundDocumentLeadToJSONTyped,
} from './InboundDocumentLead';
import type { InboundDocumentFolder } from './InboundDocumentFolder';
import {
    InboundDocumentFolderFromJSON,
    InboundDocumentFolderFromJSONTyped,
    InboundDocumentFolderToJSON,
    InboundDocumentFolderToJSONTyped,
} from './InboundDocumentFolder';
import type { InboundDocumentWorkStatus } from './InboundDocumentWorkStatus';
import {
    InboundDocumentWorkStatusFromJSON,
    InboundDocumentWorkStatusFromJSONTyped,
    InboundDocumentWorkStatusToJSON,
    InboundDocumentWorkStatusToJSONTyped,
} from './InboundDocumentWorkStatus';
import type { InboundSourceSummary } from './InboundSourceSummary';
import {
    InboundSourceSummaryFromJSON,
    InboundSourceSummaryFromJSONTyped,
    InboundSourceSummaryToJSON,
    InboundSourceSummaryToJSONTyped,
} from './InboundSourceSummary';

/**
 * 
 * @export
 * @interface InboundDocument
 */
export interface InboundDocument {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    parent_document_id?: string;
    /**
     * 
     */
    s3_key: string;
    /**
     * 
     */
    state: InboundDocumentState;
    /**
     * 
     */
    folder: InboundDocumentFolder;
    /**
     * 
     */
    work_status: InboundDocumentWorkStatus;
    /**
     * 
     */
    is_read: boolean;
    /**
     * Facilities associated with the item. Empty means unassigned. Null means every facility in the organization.
     */
    facility_ids: Array<string>;
    /**
     * 
     */
    lead?: InboundDocumentLead;
    /**
     * 
     */
    source?: InboundSourceSummary;
    /**
     * Junk documents only: the folder Restore returns to. Missing when the activity has no archive entry.
     */
    restore_folder?: InboundDocumentFolder;
    /**
     * 
     */
    date_created: Date;
    /**
     * Send back as expected_date_modified on PATCH and split.
     */
    date_modified: Date;
}



/**
 * Check if a given object implements the InboundDocument interface.
 */
export function instanceOfInboundDocument(value: object): value is InboundDocument {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('s3_key' in value) || value['s3_key'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('folder' in value) || value['folder'] === undefined) return false;
    if (!('work_status' in value) || value['work_status'] === undefined) return false;
    if (!('is_read' in value) || value['is_read'] === undefined) return false;
    if (!('facility_ids' in value) || value['facility_ids'] === undefined) return false;
    if (!('date_created' in value) || value['date_created'] === undefined) return false;
    if (!('date_modified' in value) || value['date_modified'] === undefined) return false;
    return true;
}

export function InboundDocumentFromJSON(json: any): InboundDocument {
    return InboundDocumentFromJSONTyped(json, false);
}

export function InboundDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboundDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'parent_document_id': json['parent_document_id'] == null ? undefined : json['parent_document_id'],
        's3_key': json['s3_key'],
        'state': InboundDocumentStateFromJSON(json['state']),
        'folder': InboundDocumentFolderFromJSON(json['folder']),
        'work_status': InboundDocumentWorkStatusFromJSON(json['work_status']),
        'is_read': json['is_read'],
        'facility_ids': json['facility_ids'],
        'lead': json['lead'] == null ? undefined : InboundDocumentLeadFromJSON(json['lead']),
        'source': json['source'] == null ? undefined : InboundSourceSummaryFromJSON(json['source']),
        'restore_folder': json['restore_folder'] == null ? undefined : InboundDocumentFolderFromJSON(json['restore_folder']),
        'date_created': (json['date_created'] == null ? json['date_created'] : parseDateTime(json['date_created'])),
        'date_modified': (json['date_modified'] == null ? json['date_modified'] : parseDateTime(json['date_modified'])),
    };
}

export function InboundDocumentToJSON(json: any): InboundDocument {
    return InboundDocumentToJSONTyped(json, false);
}

export function InboundDocumentToJSONTyped(value?: InboundDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'parent_document_id': value['parent_document_id'],
        's3_key': value['s3_key'],
        'state': InboundDocumentStateToJSON(value['state']),
        'folder': InboundDocumentFolderToJSON(value['folder']),
        'work_status': InboundDocumentWorkStatusToJSON(value['work_status']),
        'is_read': value['is_read'],
        'facility_ids': value['facility_ids'],
        'lead': InboundDocumentLeadToJSON(value['lead']),
        'source': InboundSourceSummaryToJSON(value['source']),
        'restore_folder': InboundDocumentFolderToJSON(value['restore_folder']),
        'date_created': value['date_created'] == null ? value['date_created'] : serializeDateTime(value['date_created']),
        'date_modified': value['date_modified'] == null ? value['date_modified'] : serializeDateTime(value['date_modified']),
    };
}

